// @flow
export { Color as default } from '@rover/design-system';



// WEBPACK FOOTER //
// ../react-lib/src/styles/Color.js